<template>
    <div class="add-entity">
        <EditDialog title="新建预警规则" width="500px" :show="show">
            <el-form size="mini" ref="form" :model="modelData" :show-message="true" label-width="130px">
                <el-form-item label="名称：" prop="PolicyName">
                    <el-input v-model="modelData.PolicyName"></el-input>
                </el-form-item>
                <el-form-item label="级别：" prop="PolicyLevel">
                    <el-select style="width: 100%" v-model="modelData.PolicyLevel">
                        <el-option label="一般" :value="2"></el-option>
                        <el-option label="严重" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期：" prop="DateType">
                    <el-select style="width: 100%" v-model="modelData.DateType" @change="onChanged">
                        <el-option label="每天" :value="1"></el-option>
                        <el-option label="节假日" :value="2"></el-option>
                        <el-option label="工作日" :value="3"></el-option>
                        <el-option label="星期" :value="4"></el-option>
                        <el-option label="自定义" :value="5"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label=" " prop="DateValue" v-if="modelData.DateType == 4 || modelData.DateType == 5">
                    <el-checkbox-group v-model="modelData.DateValue" size="mini" v-if="modelData.DateType == 4">
                        <el-checkbox-button label="1">一</el-checkbox-button>
                        <el-checkbox-button label="2">二</el-checkbox-button>
                        <el-checkbox-button label="3">三</el-checkbox-button>
                        <el-checkbox-button label="4">四</el-checkbox-button>
                        <el-checkbox-button label="5">五</el-checkbox-button>
                        <el-checkbox-button label="6">六</el-checkbox-button>
                        <el-checkbox-button label="0">日</el-checkbox-button>
                    </el-checkbox-group>
                    <el-date-picker
                        style="width: 100%"
                        v-model="modelData.DateValue"
                        type="daterange"
                        range-separator="~"
                        v-if="modelData.DateType == 5"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="客流阈值：" prop="MaxFlow">
                    <el-input-number style="width: 100%" v-model="modelData.MaxFlow" :min="1" :controls="false" />
                </el-form-item>
                <el-form-item label="最小预警频率：" prop="MinInterval">
                    <el-input-number style="width: 100%" v-model="modelData.MinInterval" :min="1" :controls="false" />
                </el-form-item>
            </el-form>
            <template #button>
                <div class="dialog-footer">
                    <el-button size="mini" @click="onSave" style="margin-right: 30px" type="primary">保存</el-button>
                    <el-button size="mini" @click="onCancel">取消</el-button>
                </div>
            </template>
        </EditDialog>
    </div>
</template>
<script>
export default {
    name: "FlowWarnPolicyAdd",
    props: {
        data: { type: Array },
        show: { type: Boolean },
    },
    data() {
        return {
            modelData: {
                PolicyID: "",
                EntityID: "",
                PolicyName: "",
                PolicyLevel: 2,
                DateType: 1,
                DateValue: [],
                MaxFlow: 1000,
                MinInterval: 20,
            },
        };
    },
    methods: {
        onChanged(e) {
            if (this.modelData.DateType == 4) {
                this.modelData.DateValue = ["1", "2", "3", "4", "5", "6", "0"];
            } else {
                this.modelData.DateValue = [];
            }
        },
        onSave() {
            if (!this.modelData.PolicyName) {
                this.$warn("请填写规则名称！");
                return;
            }
            if (this.modelData.DateType == 5 && this.modelData.DateValue.length == 0) {
                this.$warn("请选择日期！");
                return;
            }
            this.$emit("save", this.modelData);
        },
        onCancel() {
            this.$emit("close");
        },
    },
};
</script>
